import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./Filter_offcanvas.css";
import Form from "react-bootstrap/Form";
// import Datepicker from "../../../common/Datepicker";
import Datepicker from "../../common/Datepicker";
import { Select2BankData, Select2Data } from "../../../utils/common";
import { Banks, City, State } from "../../../utils/apis/masters/masters";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { useLocation } from "react-router-dom";

const Filter_offcanvas = (props) => {
  const location = useLocation();
  const isOutwardPage = location.pathname === "/outward";

  const Reset = async () => {
    await props.setValue("name", "");
    await props.setValue("contact", "");
    await props.setValue("from", "");
    await props.setValue("to", "");
    await props.setValue("state_id", "");
    await props.setValue("city_id", "");
    await props.setValue("type", "");
    await props.setValue("bank_account_id", "");
    await props.getData();
    await props.onHide();
  };

  // console.log(props.getValues(), "getValues");

  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [banks, setBanks] = useState([]);

  const getMastersData = async () => {
    {
      const res = await State();
      await setState(await Select2Data(res?.data, "state_id"));
    }
    {
      const res = await Banks();
      await setBanks(await Select2BankData(res?.data, "bank_account_id"));
    }
  };

  const handleStateSelect = async (id) => {
    const res = await City(id);
    if (res?.success) {
      await setCity(await Select2Data(res?.data, "city_id"));
    }
  };

  useEffect(() => {
    getMastersData();
  }, []);

  return (
    <>
      {/* {['end'].map((placement, idx) => ( */}
      <Offcanvas className="filter_offcanvas" {...props}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filter</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_sec">
            <div className="form-group mb-3">
              <Form.Label>Investor Name</Form.Label>
              <input
                className="form-control"
                type="text"
                id="name"
                placeholder="Search By Investor Name"
                {...props.register("name")}
              />
            </div>
            <div className="form-group mb-3">
              <Form.Label>Service No.</Form.Label>

              <input
                className="form-control"
                type="text"
                id="name"
                placeholder="Search By Service No"
                {...props.register("contact")}
              />
            </div>
            <div className="form-group mb-3">
              <Form.Label>State</Form.Label>

              <Controller
                name="state_id"
                {...props.register("state_id", {})}
                control={props.control}
                render={({ field }) => (
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                      }),
                    }}
                    classNamePrefix="custom-select-class"
                    placeholder="State"
                    {...field}
                    options={state}
                    onChange={(selectedOption) => {
                      props.setValue("state_id", null);
                      field.onChange(selectedOption);
                      handleStateSelect(selectedOption.value);
                    }}
                  />
                )}
              />
            </div>
            <div className="form-group mb-3">
              <Form.Label>District</Form.Label>

              <Controller
                name="city_id"
                {...props.register("city_id", {})}
                control={props.control}
                render={({ field }) => (
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                      }),
                    }}
                    classNamePrefix="custom-select-class"
                    placeholder="City"
                    {...field}
                    options={city}
                    onChange={(selectedOption) => {
                      props.setValue("city_id", null);
                      field.onChange(selectedOption);
                      // handleStateSelect(selectedOption.value);
                    }}
                  />
                )}
              />
            </div>
            {isOutwardPage && (
              <div className="form-group mb-3">
                <Form.Label>Type</Form.Label>

                <Controller
                  name="type"
                  {...props.register("type", {})}
                  control={props.control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                        }),
                      }}
                      classNamePrefix="custom-select-class"
                      placeholder="Select Type"
                      {...field}
                      options={[
                        {
                          value: "Profit Withdrawn",
                          label: "Profit Withdrawn",
                        },
                        { value: "Funds Withdrawn", label: "Fund Withdrawn" },
                      ]}
                      onChange={(selectedOption) => {
                        props.setValue("type", selectedOption?.value ?? null);
                        field.onChange(selectedOption);
                      }}
                    />
                  )}
                />
              </div>
            )}

            <div className="form-group mb-3">
              {/* <Form.Label>Date Range</Form.Label> */}
              <Datepicker
                reset={props.reset}
                getValues={props.getValues}
                setValue={props.setValue}
                className="mt-3"
              />
            </div>

            <div className="form-group mb-3">
              <Form.Label>Bank</Form.Label>

              <Controller
                name="bank_account_id"
                {...props.register("bank_account_id", {})}
                control={props.control}
                render={({ field }) => (
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                      }),
                    }}
                    classNamePrefix="custom-select-class"
                    placeholder="Bank"
                    {...field}
                    options={banks}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                    }}
                  />
                )}
              />
            </div>

            <div className="form-group mb-3">
              <button
                className="submitbtn"
                onClick={() => {
                  props.getData();
                  props.onHide();
                }}
              >
                Search
              </button>
              <button className="resetbtn ms-3" onClick={Reset}>
                Reset
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      {/* ))} */}
    </>
  );
};

export default Filter_offcanvas;
